import React from "react";
import { Text, Flex } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { observer } from "mobx-react-lite";

const AgentTeamsList = observer((props) => {
    const { agent } = props;
    const teamItems = [];

    // order by team name 
    const sortedTeams = [...agent.teams].sort((a, b) => {
        return a.team.name.localeCompare(b.team.name);
    });

    sortedTeams.forEach(team => {
        let classes = ["team-members-status"];
        classes.push(team.loggedIn ? "green" : "red");
        const loggedInIcon = <FontAwesomeIcon className={classes.join(" ")} icon={faUser} />;

        teamItems.push((
            <Flex
                data-testid="rowAgentTeamsTeam"
                vAlign="center"
                gap="gap.smaller"
                key={agent.id + '-Team-' + team.team.name}>
                {loggedInIcon}
                <Text>{team.team.name}</Text>
            </Flex>
        )
        );
    });

    return (
        <Flex data-testid="rowAgentTeams" gap="gap.medium" wrap>
            {teamItems}
        </Flex>
    );
});

AgentTeamsList.propTypes = {
    agent: PropTypes.object,
};

AgentTeamsList.defaultProps = {
    agent: {},
};

export default AgentTeamsList;
